export default __webpack_public_path__ + "static/media/pirate_scarf.41d9eaf6.svg";